<template>
  <section>
    <div class="dropdown" :class="{ is_dark: isDark }">
      <select v-model="value">
        <option v-for="option in options" :value="option.value" :key="`${option.value}`">
          {{ label(option.label) }}
        </option>
      </select>
      <span class="selection_preview" :class="{ is_raw: raw, switch_hover: switchHover, is_hovered: isDark }">{{
        $t(selectedLabel)
      }}</span>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    options: Array,
    defaultValue: null,
    raw: {
      type: Boolean,
      value: false,
    },
    isDark: {
      type: Boolean,
      value: false,
    },
    switchHover: {
      type: Boolean,
      value: false,
    },
  },
  data() {
    return {
      value: null,
    }
  },
  computed: {
    selectedLabel() {
      return this.options.find((v) => v.value === this.value)?.label
    },
  },
  created() {
    this.value = this.defaultValue
  },
  methods: {
    label(label) {
      if (+label) {
        return label
      } else {
        return this.$t(label)
      }
    },
  },
  watch: {
    value(newValue) {
      this.$emit('value-change', newValue)
    },
    defaultValue(newValue) {
      const isValueExistInOptions = this.options.some((v) => v.value === newValue)
      if (!isValueExistInOptions) return

      this.value = newValue
    },
  },
}
</script>

<style lang="scss" scoped>
section {
  position: relative;
  display: inline-block;
  cursor: pointer;

  .dropdown {
    display: inline-block;
    border-radius: 200px;
    min-width: 84px;
    &.is_active {
      .selection_preview {
        &:after {
          opacity: 1;
        }
      }
    }

    &.is_dark {
      background: #000;
      border-radius: 20px;
      color: #fff;

      .selection_preview {
        &:after {
          border-left-color: #fff;
          border-bottom-color: #fff;
        }
      }
    }
  }

  .selection_preview {
    @include fontStyleNavi;
    // font-size: 14px;
    position: relative;
    padding: 0;
    display: inline-block;
    padding: 10px 35px 10px 15px;
    border: 1px solid #000;
    border-radius: 20px;
    width: 100%;
    transition: background-color 0.3s, color 0.3s;

    &.is_raw {
      border: 0;
    }

    &:after {
      content: '';
      display: block;
      width: 7px;
      height: 7px;
      border-left: 1px solid $colorBlack;
      border-bottom: 1px solid $colorBlack;
      transform: rotate(-45deg);
      position: absolute;
      top: calc(50% - 7px);
      right: 15px;
      opacity: 1;
      transition: border-color 0.3s;
    }
  }

  select {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    z-index: 4;
    cursor: pointer;

    &:hover ~ .selection_preview {
      background: $colorBeigeDarkHover;

      &.is_raw {
        background: $colorBeige;
        color: $colorBlack;

        &:after {
          border-left-color: $colorBlack;
          border-bottom-color: $colorBlack;
        }
      }

      &.is_dark {
        background: $colorBeigeDark;
        color: $colorBlack;

        &:after {
          border-left-color: $colorBlack;
          border-bottom-color: $colorBlack;
        }
      }

      &.switch_hover {
        background: $colorBeigeDark;
        color: $colorBlack;

        &:after {
          border-left-color: $colorBlack;
          border-bottom-color: $colorBlack;
        }
      }

      &.switch_hover.is_hovered {
        background: $colorBlack;
        color: $colorWhite;

        &:after {
          border-left-color: $colorWhite;
          border-bottom-color: $colorWhite;
        }
      }
    }
  }
}
</style>
